import styled from 'styled-components';
import theme from '../../../../styles/defaultTheme';

export const HeaderLabel = styled.span`
  font-size: ${theme.font.size20};
  font-weight: bold;
  color: ${(props) => props.theme.black};
  display: inline-block;
`;

export const DescriptionLabel = styled.span`
  font-size: ${theme.font.size14};
  color: ${(props) => props.theme.black};
  display: inline-block;
  padding-top: 16px;
`;

export const LinkLabel = styled.a`
  font-size: ${theme.font.size14};
  color: ${(props) => props.theme.orangeLink};
  text-decoration: underline;
  border: none;
  background: none;
  cursor: pointer;
`;

export const ButtomCard = styled.button`
  width: 100%;
  max-width: 430px;
  min-height: 108px;
  text-align: left;
  background-color: #ffffff;
  border: 1px solid #d5d5d5;
  border-radius: 8px;
  margin-bottom: 10px;
  cursor: pointer;
  outline: none;
`;

export const Title = styled.div`
  font-size: ${theme.font.size18};
  font-weight: bold;
  color: #ec6e0c;
  text-align: left;
  color: #ec6e0c;
  margin-right: 10px;
`;

export const Desc = styled.div`
  font-size: ${theme.font.size14};
  color: #5b5b5f;
  text-align: left;
  margin-right: 10px;
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
  padding: 0 0 32px 0;
  gap: 24px;

  & button {
    
    height: 48px;
  }

  & input {
    background-color: ${(props) => props.theme.white};
    padding: 8px 0px 0px 8px;
    width: 100%;
    min-height: 44px;
    text-align: left;
    border: 1px solid #d5d5d5;
    border-radius: 8px;
    cursor: pointer;
    outline: none;

    font-size: ${theme.font.size14};
  }

  @media (max-width: 900px) {
    flex-direction: column;
    margin: 0;

    & div,
    & button {
      width: 100%;
    }

    & button {
      margin: 10px 0;
      margin-bottom: 25px;
    }

    & input {
      width: 100%;
    }
  }
`;

export const LinkToConsultShipping = styled.button`
  text-decoration: underline;
  border: none;
  background: none;
  cursor: pointer;
`;

export const LinkCardModel = styled.div`
  display: flex;
  margin: 0 0 32px 0;
`;

export const SendFileText = styled.div`
  font: ${theme.font.body[6]};
  letter-spacing: 0px;
  color: ${(props) => props.theme.grey};
`;

export const ContainerRadio = styled.div`
    margin: 6px 0 -16px 0;
`;
